import React from "react";
type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "solid" | "outline" | "ghost"; size?: "sm"|"md"; };
export default function Button({ variant="solid", size="md", className="", ...rest }: Props) {
  const base =
    "inline-flex items-center justify-center rounded-[10px] font-medium transition disabled:opacity-50 disabled:cursor-not-allowed";
  const sizes = size==="sm" ? "h-9 px-3 text-sm" : "h-10 px-4 text-sm";
  const theme = variant==="solid"
    ? "bg-[#0EA35C]/85 hover:bg-[#0EA35C] text-white disabled:hover:bg-[#0EA35C]/85"
    : variant==="outline"
      ? "border border-[#D1D5DB] bg-white hover:bg-black/[0.03] text-[#111] disabled:hover:bg-white"
      : "text-[#111] hover:bg-black/[0.05] disabled:hover:bg-transparent";
  return <button className={[base, sizes, theme, className].join(" ")} {...rest} />;
}
